import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { BOOKING_URL } from '../data/landing';
import { trackCalendlyConversion } from './GoogleTagLoader';
export function FinalCTASection() {
  return <section className="bg-indigo-700 py-20 text-white sm:py-24" data-id="element-72" data-mp="3s1whkh6nxqd7">
      <div className="mx-auto max-w-5xl px-4 text-center sm:px-6 lg:px-8" data-id="element-73" data-mp="vv2zynhoemt">
        <h2 className="text-3xl font-semibold tracking-[-0.02em] sm:text-5xl" data-id="element-74" data-mp="v3grefs7t97">Do not wait for foot traffic to create pipeline.</h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-indigo-100" data-id="element-75" data-mp="34clg0xhhnry0">
          Tell us the conference, your ICP, and how many reps are attending. We
          will map the campaign and meeting target with you.
        </p>
        <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" onClick={trackCalendlyConversion} className="mt-8 inline-flex min-h-12 items-center justify-center rounded-lg bg-white px-6 font-bold text-indigo-800 transition-colors duration-150 hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-700" data-id="element-76" data-mp="3e3gb8rcpq1vl">
          Plan my next show<ArrowUpRightIcon className="ml-2 h-4 w-4" aria-hidden="true" data-id="element-77" data-mp="21vo39q4e2go2" />
        </a>
      </div>
    </section>;
}